<template>
  <div class="d-flex flex-column">
      <div>
        <img src="@/assets/img/statistics/no-data.svg" />
      </div>
      <h2>暫無數據</h2>
  </div>
</template>

<script>
export default {
  name: 'NoDataState',
};
</script>
